<template>
  <v-tabs v-model="activeTab">
    <v-tab v-for="item of tabItems" :key="item.index">
      <v-icon v-if="item.icon" left>{{ item.icon }}</v-icon>
      {{ item.title }}
    </v-tab>

    <v-tab-item v-for="item of tabItems" :key="item.index">
      <v-card flat>
        <component :is="item.content"></component>
      </v-card>
    </v-tab-item>
  </v-tabs>
</template>

<script>
  import KidPurchasedGiftList from "@/components/Kids/PurchasedGift/KidPurchasedGiftList";
  import KidGiftWishlist from "@/components/Kids/KidGiftWishlist";

  export default {
    name: "KidGiftsInfoTabs",

    data() {
      return {
        tabItems: [
          {
            index: 0,
            title: "Redeemed Rewards",
            icon: "",
            content: KidPurchasedGiftList,
          },
          {
            index: 1,
            title: "Wishlist",
            icon: "",
            content: KidGiftWishlist,
          },
        ],
      };
    },

    computed: {
      activeTab: {
        get() {
          return this.$route.name === "KidGiftWishlist" ? 1 : 0;
        },
        set(newValue) {
          return newValue;
        },
      },
    },

    components: {
      KidPurchasedGiftList,
      KidGiftWishlist,
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Kids/KidGiftsInfoTabs.vue